import { Factory } from './factory';
import { PageDrawing } from '../page-drawing';

export class PageDrawingFactory implements Factory<PageDrawing> {

    buildFromFactory(): PageDrawing {
        return undefined;
    }

    buildFromObject(jsonObject: any): PageDrawing {

        const pageDrawing = jsonObject;
        pageDrawing.fabricObject = JSON.parse(jsonObject.fabricCanvas);

        return pageDrawing;
    }
}
